import { useEffect, useId, useState } from "react";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";

let bankaIstek = null;
const bankalariGetir = () => { bankaIstek = bankaIstek || api.get("/bankalar").then((r) => r.data).catch(() => { bankaIstek = null; return []; }); return bankaIstek; };

export const ibanBicim = (v) => {
  const d = String(v || "").toUpperCase().replace(/\s/g, "").replace(/^TR/, "").replace(/\D/g, "").slice(0, 24);
  return d ? `TR${d}`.replace(/(.{4})/g, "$1 ").trim() : "";
};
export const ibanBankaKodu = (v) => { const d = ibanBicim(v).replace(/\s/g, "").slice(2); return d.length >= 7 ? d.slice(3, 7) : ""; };

// "TR" sabit; rakamlar TR11 1111 1111 1111 1111 1111 11 düzeninde gruplanır
export const IbanInput = ({ value, onChange, onBanka, testid = "iban", className = "" }) => {
  const tam = ibanBicim(value);
  const rakam = tam.replace(/\s/g, "").slice(2);
  const gorunen = rakam ? [rakam.slice(0, 2), ...(rakam.slice(2).match(/.{1,4}/g) || [])].join(" ") : "";
  const degis = (e) => {
    const yeni = ibanBicim(`TR${e.target.value.replace(/^\s*TR/i, "")}`);
    onChange(yeni);
    const kod = ibanBankaKodu(yeni);
    if (kod && kod !== ibanBankaKodu(tam)) bankalariGetir().then((l) => { const b = l.find((x) => x.kod === kod); if (b) onBanka?.(b.ad); });
  };
  return (
    <div className={`flex h-9 w-full items-center rounded-md border border-input bg-white/5 focus-within:ring-1 focus-within:ring-ring ${className}`} data-testid={`${testid}-kutu`}>
      <span className="pl-3 pr-1.5 font-mono text-sm font-semibold text-[var(--g1)] select-none">TR</span>
      <input data-testid={testid} inputMode="numeric" autoComplete="off" value={gorunen} onChange={degis} placeholder="00 0000 0000 0000 0000 0000 00"
        className="h-full w-full min-w-0 bg-transparent pr-3 font-mono text-sm outline-none placeholder:text-muted-foreground/60" />
      <span className="pr-3 text-[10px] text-muted-foreground whitespace-nowrap" data-testid={`${testid}-sayac`}>{rakam.length}/24</span>
    </div>
  );
};

export const BankaInput = ({ value, onChange, testid = "banka", className = "" }) => {
  const id = useId();
  const [l, setL] = useState([]);
  useEffect(() => { bankalariGetir().then(setL); }, []);
  return <>
    <Input data-testid={testid} list={id} autoComplete="off" placeholder="Banka adı yazın veya seçin" className={`bg-white/5 ${className}`} value={value || ""} onChange={(e) => onChange(e.target.value)} />
    <datalist id={id}>{l.map((b) => <option key={b.kod} value={b.ad}>{b.kod}</option>)}</datalist>
  </>;
};

export const SubeInput = ({ banka, il, value, onChange, testid = "sube", className = "" }) => {
  const id = useId();
  const [l, setL] = useState([]);
  const q = (value || "").trim().length >= 2 ? value.trim() : "";
  useEffect(() => {
    if (!(banka || "").trim()) { setL([]); return undefined; }
    const t = setTimeout(() => api.get("/banka-subeleri", { params: { banka, il: il || "", q } }).then((r) => setL(r.data.subeler)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [banka, il, q]);
  return <>
    <Input data-testid={testid} list={id} autoComplete="off" placeholder={banka ? "Şube adı yazın veya seçin" : "Önce bankayı seçin"} className={`bg-white/5 ${className}`} value={value || ""} onChange={(e) => onChange(e.target.value)} />
    <datalist id={id}>{l.map((s) => <option key={`${s.kod}-${s.ad}`} value={s.ad}>{[s.kod, s.ilce, s.il].filter(Boolean).join(" · ")}</option>)}</datalist>
  </>;
};
